import { adminFetch } from "./_client";
import type { SambaTokenInfo, SambaMvrSubmitResult, SambaSimulateWebhookResult, SambaMvrFetchResponse } from "./types";


export function sambaFetchToken(token: string, env: "prod" | "demo") {
  return adminFetch<{ success: boolean; info: SambaTokenInfo }>("/admin/tools/samba/token", token, {
    method: "POST",
    body: JSON.stringify({ env }),
  });
}


export function sambaSubmitMvr(token: string, body: { env: "prod" | "demo"; licenseNumber: string; licenseState: string; firstName: string; lastName: string; dateOfBirth: string; host?: string; productId?: string; purpose?: string; subType?: string }) {
  return adminFetch<{ success: boolean; order: SambaMvrSubmitResult }>("/admin/tools/samba/submit-mvr", token, {
    method: "POST",
    body: JSON.stringify(body),
  });
}


export function sambaFetchMvr(token: string, body: { env: "prod" | "demo"; orderId: string }) {
  return adminFetch<SambaMvrFetchResponse>("/admin/tools/samba/fetch-mvr", token, {
    method: "POST",
    body: JSON.stringify(body),
  });
}


export function sambaSimulateWebhook(token: string, body: { orderId?: string; result: unknown }) {
  return adminFetch<SambaSimulateWebhookResult>("/admin/tools/samba/simulate-webhook", token, {
    method: "POST",
    body: JSON.stringify(body),
  });
}
